import ProductCards from "../ProductCards";
import UserFavorites from "./UserFavorites";

export enum PROFILE_TABS {
  OWNED = "owned",
  FAVORITED = "favorited",
}

const tabMap = {
  [PROFILE_TABS.OWNED]: ProductCards,
  [PROFILE_TABS.FAVORITED]: UserFavorites,
};

export const renderTab = (tab: string, swooshHandle: string) => {
  const TabComponent = tabMap[tab as PROFILE_TABS] ?? ProductCards;
  return <TabComponent swooshHandle={swooshHandle} />;
};
